import { create } from 'zustand';

type ChatOpenState = {
    readonly isOpen: boolean;
    readonly close: () => void;
    readonly open: () => void;
    readonly toggle: () => void;
};

export const useChatStore = create<ChatOpenState>((set) => ({
    close: () =>
        set((state) => {
            if (!state.isOpen) {
                return state;
            }

            return { isOpen: false };
        }),
    isOpen: false,
    open: () =>
        set((state) => {
            if (state.isOpen) {
                return state;
            }

            return { isOpen: true };
        }),
    toggle: () => set((state) => ({ isOpen: !state.isOpen })),
}));

export const useChatOpen = (): boolean => useChatStore((state) => state.isOpen);
